<i18n src="../../locales/lang.json"></i18n>
<template>
  <div style="position:absolute;">
    <modal-default v-bind:hideButtons="sharingOption" v-bind:title="title" ref="thisModal" v-bind:onsave="doSave" size="modal-xs mx-4 mx-md-auto">
      <div style="max-height:calc(100vh - 270px);overflow-y:auto">

        <div class="container-fluid pb-3">
          <div class="form-group">
            <div class="row mt-3" v-show="showUserSelect == true">
              <div class="col-12 custom-form-label">
                {{$t('user')}}
              </div>
            </div>
            <div class="row mt-1" v-show="showUserSelect == true">
              <div class="col-sm-12">
                <select class="form-control select-search" data-fouc v-bind:id="'select_assigned_user_' +  getId()" v-select>
                  <option value="" style="">{{ $t('select_user') }}</option>
                  <option v-for="user in users" v-bind:value="user.User">
                    {{ user.Name }}
                  </option>
                  <option value="new" style="">{{ $t('new') }}</option>
                </select>
              </div>
            </div>
            <div class="row mt-1" v-show="showAddUser == true">
              <div class="col-12 custom-form-label">
                {{$t('new_user_mail_or_phone')}}
              </div>
            </div>
            <div class="row mt-1" v-show="showAddUser == true">
              <div class="col-7">
                <input v-bind:placeholder="$t('username')" type="text" class="form-control" v-model="newUserName">
              </div>
              <div class="col-5 text-right">
                <button type="button" @click="addUser" class="btn skin primary-button col-12">{{$t('add')}}</button>
              </div>
            </div>
          </div>


          <div class="form-group" v-show="userOrganisations.length>0 && optionalvisible == true">
            <div class="row mt-3">
              <div class="col-12 custom-form-label">
                {{$t('organisation_optional')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-sm-12">
                <select class="form-control select-search" data-fouc v-bind:id="'select_assigned_Organisation_' +  getId()">
                  <option value="-1" style="">{{ $t('Organisation') }}</option>
                  <option v-for="Organisation in userOrganisations" v-bind:value="Organisation.Organisationid">
                    {{ Organisation.Organization }}
                  </option>
                  <option value="new" style="">{{ $t('new') }}</option>
                </select>
              </div>
            </div>
            <div class="row mt-1" v-if="showAddOrganisation == true">
              <div class="col-12 custom-form-label">
                {{$t('organisation')}}
              </div>
            </div>
            <div class="row mt-1" v-if="showAddOrganisation == true">
              <div class="col-7">
                <input v-bind:placeholder="$t('organisation')" type="text" class="form-control" v-model="newOrganisationName">
              </div>
              <div class="col-5 text-right">
                <button type="button" @click="addOrganisation" class="btn skin primary-button col-12">{{$t('add')}}</button>
              </div>
            </div>
          </div>

          <div class="form-group" v-show="teams.length>0 && optionalvisible == true">
            <div class="row mt-3">
              <div class="col-12 custom-form-label">
                {{$store.translate('team_optional')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-sm-12">
                <team-select-selector ref="teamSelectorRef" @event-change-team="onChangeTeam"></team-select-selector>
              </div>
            </div>
          </div>

          <div class="form-group" v-show="locations.length>0 && optionalvisible == true">
            <div class="row mt-3">
              <div class="col-12 custom-form-label">
                {{ $store.translate('location_optional')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-sm-12">
                <select class="form-control select-search" data-fouc v-bind:id="'select_location_' +  getId()">
                  <option value="" style="">{{ $store.translate('location') }}</option>
                  <option v-for="location in locations" v-bind:value="location.LocationId"
                          v-bind:class="location.ParentId!==null?'option_child_loc':''">
                    {{ location.LocationName }}
                  </option>
                  <option value="new" style="">{{ $t('new') }}</option>
                </select>
              </div>
            </div>
            <div class="row mt-1" v-if="showAddLocation == true">
              <div class="col-12 custom-form-label">
                {{$t('location')}}
              </div>
            </div>
            <div class="row mt-1" v-if="showAddLocation == true">
              <div class="col-7">
                <input v-bind:placeholder="$t('location')" type="text" class="form-control" v-model="newLocationName">
              </div>
              <div class="col-5 text-right">
                <button type="button" @click="addLocation" class="btn skin primary-button col-12">{{$t('add')}}</button>
              </div>
            </div>
          </div>



          <div class="form-group" v-show="projects.length>0 && optionalvisible == true">
            <div class="row mt-3">
              <div class="col-12 custom-form-label">
                {{$t('project_optional')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-sm-12">
                <select class="form-control select-search" data-fouc v-bind:id="'select_assigned_project_' +  getId()">
                  <option value="" style="">{{ $t('project') }}</option>
                  <option v-for="project in projects" v-bind:value="project.ProjectId">
                    {{ project.Name }}
                  </option>
                  <option value="new" style="">{{ $t('new') }}</option>
                </select>
              </div>
            </div>
          </div>


          <div class="form-group" v-show="shifts.length>0 && optionalvisible == true">
            <div class="row mt-3">
              <div class="col-12 custom-form-label">
                {{ $store.translate('shift_optional')}}
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-sm-12">
                <shift-select-selector ref="shiftSelectorRef" @event-change-shift="onChangeShift"></shift-select-selector>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row mt-3" v-show="optionalvisible == true">
              <div class="col-6 custom-form-label">
                {{$t('start_date')}}
              </div>
              <div class="col-6 custom-form-label">
                {{$t('start_time')}}
              </div>
            </div>
            <div class="row mt-1" v-show="optionalvisible == true">
              <div class="col-6">
                <input v-bind:placeholder="$t('date')" type="text" class="form-control calendarassignment" name="date" v-bind:id="'txt_date_assign_' +  getId()">
              </div>
              <div class="col-6">
                <input type="text" v-bind:id="'txt_time_' +  getId()" placeholder="hh:mm" class="form-control" style="display:inline;" />
              </div>
            </div>


            <div class="row mt-3" v-show="optionalvisible == true">
              <div class="col-6 custom-form-label">
                {{$t('end_date')}}
              </div>
              <div class="col-6 custom-form-label">
                {{$t('end_time')}}
              </div>
            </div>
            <div class="row mt-1" v-show="optionalvisible == true">
              <div class="col-6">
                <input v-bind:placeholder="$t('date')" name="enddate" type="text" v-bind:id="'txt_enddate_assign_' +  getId()" class="form-control calendarassignment" style="display:inline;" />
              </div>
              <div class="col-6">
                <input type="text" v-bind:id="'txt_endtime_' +  getId()" placeholder="hh:mm" class="form-control" style="display:inline;" />
              </div>
            </div>

            <div v-show="sharingOption == true">
              <div class="row mt-3">
                <div class="col-12">
                  {{ $t('sharing_options') }}:
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12">
                  <select class="form-control" v-model="selectedAuth" @change="changedAuth" v-bind:id="'select_authtype_' +  getId()">
                    <option value="authentication" style="">{{ $t('authentication_require') }}</option>
                    <option value="onlyemail" style="">{{ $t('simple_email') }}</option>
                    <option value="anonymous" style="">{{ $t('anonymous') }}</option>
                  </select>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12 text-center">
                  <button v-bind:id="'copyButton_' + getId()" type="button" class="btn skin primary-button col-12"><i class="icon-link mt-0 mr-1"></i>{{$t('share_with_link')}}</button>
                </div>
              </div>
              <div class="row mt-1" v-if="copyError == true">
                <div class="col-12 text-center">
                  Could not copy url, please copy it manually
                </div>
              </div>
              <!--<div class="row mt-1 custom-form-label" v-if="optionalvisible == true">
                <div class="col-12 text-center">
                  <input-checkbox @input="setOverride" v-bind:value="1" v-bind:id="'chk_IsAuthRequire' +  getId()"
                                  v-bind:name="'chk_IsAuthRequire' +  getId()" v-bind:checked="isAuthRequire"
                                  v-bind:text="$store.translate('authentication_require')" class="mt-1"></input-checkbox>
                </div>
              </div>-->
              <div class="row mt-0" v-if="confirmCopy == true">
                <div class="col-12 text-center">
                  <label class="custom-form-label">{{$t('copied_to_clipboard')}}</label>
                </div>
              </div>
              <div class="row mt-1" v-if="qrcodevisible == false">
                <div class="col-12 text-center">
                  <button class="btn skin primary-button col-12" @click="showQRCode"><i class="icon-qrcode mt-0 mr-1"></i>{{$t('share_with_qr_code')}}</button>
                </div>
              </div>
              <div class="row mt-1" v-show="qrcodevisible == true">
                <div class="col-12 text-center">
                  <img width="100" @click="printImage" height="100" v-bind:src="qrsource" />
                </div>
                <div v-show="false">{{ qrcodeurl }}</div>
              </div>

              <div class="row mt-3" v-show="qrcodevisible == true">
                <div class="col-12 text-center">
                  <button class="btn skin primary-button" @click="printImage">{{$t('print_qr_code_button_text')}}</button>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12 text-center">
                  <button class="btn skin primary-button col-12" @click="showEmailOrSms"><i class="icon-envelop2 mt-0 mr-1"></i>{{$t('share_with_email_sms')}}</button>
                </div>
              </div>
              <div class="col-12 p-0" v-show="shareemailorsms == true">
                <form id="shareEmailSmsForm" name="shareEmailSmsForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
                  <div class="row mt-1">
                    <div class="col-12 text-center">
                      <input type="text" v-model="sendORSms" required v-bind:id="'txt_emailsms_' +  getId()" v-bind:placeholder="$t('email_or_sms')" class="form-control" style="display:inline;" />
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-12 text-center">
                      <button @click="sendEmailForUrl" v-bind:id="'shareemailorsmsButton_' + getId()" type="submit" class="btn skin primary-button col-12">{{$t('send')}}</button>
                    </div>
                  </div>
                  <div class="row mt-0">
                    <div class="col-12 text-center">
                      <label class="custom-form-label">{{msgSmsOrEmail}}</label>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="row mt-3" v-if="optionalvisible == false && hideShowMoreOption==false">
              <div class="col-12 text-center">
                <button class="btn btn-light col-12" @click="showOptional">{{$t('show_more_options')}} <i class="icon-arrow-down32 ml-3"></i></button>
              </div>
            </div>
            <div class="row mt-3 pt-3" v-if="optionalvisible == true && hideShowMoreOption==false">
              <div class="col-12 text-center">
                <button class="btn btn-light col-12" @click="hideOptional">{{$t('show_less_options')}} <i class="icon-arrow-up32 ml-3"></i></button>
              </div>
            </div>
          </div>

        </div>


      </div>
    </modal-default>
  </div>

</template>

<script>
  var isAuthRequire = false;
  var OrganisationId = -1;
  var shiftId = -1;
  var thisProcedure = {};
  var locations = [];
  var users = [];
  var projects = [];
  var shifts = [];
  var teams = [];
  var assignedUser = "";
  var assignedProjectId = null;
  var selectedLocation = "";
  let userOrganisations = [];
  var qrcodevisible = false;
  var optionalvisible = false;
  var showAddUser = false;
  var showAddLocation = false;
  var showAddOrganisation = false;
  var newUserName = "";
  var newOrganisationName = "";
  var newLocationName = "";
  var sharingOption = false;
  var showUserSelect = true;
  var shareemailorsms = false;
  import ModalDefault from "../modals/modal-default.vue";
  import TeamSelector from '../team/team-select-selector'
  import ShiftSelector from '../shift/shift-select-selector.vue'


  export default {
    name: "procedure-assign",
    components: {
      ModalDefault,
      TeamSelector,
      ShiftSelector
    },
    props: {
      user: {
        type: String,
        default: ""
      },
      siteid: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        newUserName,
        newOrganisationName,
        newLocationName,
        showAddUser,
        showAddLocation,
        showAddOrganisation,
        isAuthRequire: false,
        procedureId: 0,
        optionalvisible,
        qrcodevisible,
        shareemailorsms: false,
        OrganisationId: -1,
        shiftId: -1,
        assignedUser,
        assignedProjectId,
        selectedLocation,
        selectedTeam: null,
        selecteddate: '',//'2020-11-23',
        procedureScheduleId: null,
        users,
        projects,
        shifts,
        teams,
        locations,
        thisProcedure,
        userOrganisations,
        qrcodeurl: '',
        isLoaded: false,
        procedure: null,
        confirmCopy: false,
        selectedAuth: 'authentication',
        sharingOption: false,
        hideShowMoreOption: false,
        showUserSelect: true,
        title: "",
        copyError: false,
        copyUrl: '',
        sendORSms: '',
        msgSmsOrEmail: '',
      };
    },
    methods: {
      showEmailOrSms() {
        this.qrcodevisible = false;
        this.shareemailorsms = !this.shareemailorsms;
      },
      changedAuth() {
        this.getQRCodeUrl();
        this.$forceUpdate();
      },
      addLocation() {
        var thisContext = this;
        var request = {
          name: this.newLocationName,
        };
        try {
          var response = this.$http.post(
            '/api/Locations/v1/ByName',
            request
          ).then(response => {
            thisContext.selectedLocation = response.data.locationid;
            //alert("the new location:" + response.data.locationid)
            thisContext.loadLocations();
            thisContext.showAddLocation = false;
          });

        } catch (err) {
          alert(err);
        }
      },
      addOrganisation() {
        var thisContext = this;
        var request = {
          Organization: this.newOrganisationName,
        };
        try {
          var response = this.$http.post(
            '/api/Organization/CreateOrUpdate',
            request
          ).then(response => {
            this.getUserOrganisations(this.user);
            //thisContext.assignedUser = thisContext.newOrganisationName;
            thisContext.showAddOrganisation = false;
            thisContext.getUserOrganisations(thisContext.Username);
          });

        } catch (err) {
          alert(err);
        }
      },
      addUser() {

        this.doAddUser(this.newUserName, this.newUserName);
      },
      doAddUser(username, email) {
        var thisContext = this;
        var request = {
          username: username,
          //email: email,
        };
        try {
          var response = this.$http.post(
            '/api/Users/v1/InviteSimple',
            request
          ).then(response => {
            thisContext.assignedUser = thisContext.newUserName;
            thisContext.loadMembers();
            thisContext.showAddUser = false;
          });

        } catch (err) {
          alert(err);
        }
      },
      setOverride(checked, val, value) {
        this.isAuthRequire = checked;
      },
      copy_old(url) {
        var thisContext = this;
        var el = document.createElement('textarea');
        el.setAttribute('readonly', false);
        el.contentEditable = true;
        el.value = url;
        el.style.position = 'absolute';
        el.style.left = '-9999px';

        document.body.appendChild(el);
        el.select();
        el.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text inside the text field

        navigator.clipboard.writeText(el.value).then(() => {
          document.body.removeChild(el);
          thisContext.confirmCopy = true;
        }).catch(() => {
          alert("could not copy")
          thisContext.copyError = true;
        });
      },
      async copy(text) {
        //https://stackoverflow.com/questions/69438702/why-does-navigator-clipboard-writetext-not-copy-text-to-clipboard-if-it-is-pro
        return new Promise(async (resolve, reject) => {

          if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
              document.execCommand("copy");
              document.body.removeChild(textarea);
              resolve();
            }
            catch (e) {
              document.body.removeChild(textarea);
              reject(e);
            }
          }
          else if (typeof navigator !== "undefined" && typeof navigator.clipboard !== "undefined" && typeof ClipboardItem !== "undefined") {
            const type = "text/plain";
            const blob = new Blob([text], { type });
            const data = [new ClipboardItem({ [type]: blob })];
            try {
              let result = await navigator.clipboard.write(data);
            }
            catch (error) {

              reject(new Error("Permission not granted!"));
            }
          }
          else {
            reject(new Error("None of copying methods are supported by this browser!"));
          }
        });
      },
      showQRCode() {
        this.shareemailorsms = false;
        this.qrcodevisible = !this.qrcodevisible;
        if (this.qrcodevisible == true)
          this.getQRCodeUrl();
      },
      showOptional() {
        this.optionalvisible = true;
        this.showUserSelect = true;
      },
      hideOptional() {
        this.optionalvisible = false;
        this.showUserSelect = !this.sharingOption;
      },

      resetControls() {
        this.msgSmsOrEmail = '';
        this.sendORSms = '';
        this.confirmCopy = false;
        this.procedure = null;
        this.procedureScheduleId = null;
        $("#select_location_" + this.getId()).val("");
        $("#select_location_" + this.getId()).trigger('change');

        $("#select_assigned_Organisation_" + this.getId()).val(-1);
        $("#select_assigned_Organisation_" + this.getId()).trigger('change');

        $("#select_assigned_user_" + this.getId()).val("");
        $("#select_assigned_user_" + this.getId()).trigger('change');

        $("#select_assigned_project_" + this.getId()).val("");
        $("#select_assigned_project_" + this.getId()).trigger('change');

        //$("#select_assigned_shift_" + this.getId()).val("");
        //$("#select_assigned_shift_" + this.getId()).trigger('change');
        if (this.$refs.shiftSelectorRef)
          this.$refs.shiftSelectorRef.selectShift("");

        $("#txt_date_assign_" + this.getId()).val("");
        $("#txt_enddate_assign_" + this.getId()).val("");
        $("#txt_time_" + this.getId()).val(''),
          $("#txt_endtime_" + this.getId()).val('')

        if (this.$refs.teamSelectorRef)
          this.$refs.teamSelectorRef.selectTeam("");

        this.qrcodevisible = false;
        this.sharingOption = false;
        this.shareemailorsms = false;
        //this.title = this.$t('assign_to');
      },
      setProcedureScheduleData(data) {
        this.initInitial();
        //alert('This is where the assign component should be updated with all values')
        //alert("data from backend:" + JSON.stringify(data));
        var thisContext = this;
        setTimeout(function () {
          thisContext.reloadData(data);
        }, 1000)
      },
      reloadData(data) {
        if (data != null) {
          this.procedure = data;
          this.procedureId = data.ProcedureId;

          this.procedureScheduleId = data.id;
          if (data.LocationId != null) {
            this.selectedLocation = data.LocationId;
            $("#select_location_" + this.getId()).val(data.LocationId);
            $("#select_location_" + this.getId()).trigger('change');
          }
          else
            this.selectedLocation = null;

          if (data.AssignTo != null && data.AssignTo != '') {
            $("#select_assigned_user_" + this.getId()).val(data.AssignTo);
            $("#select_assigned_user_" + this.getId()).trigger('change');
            this.assignedUser = data.AssignTo + "";
          }
          else {
            this.assignedUser = "";
          }


          if (data.OrganisationId != null) {
            this.OrganisationId = data.OrganisationId;
            $("#select_assigned_Organisation_" + this.getId()).val(data.OrganisationId);
            $("#select_assigned_Organisation_" + this.getId()).trigger('change');
          }
          else
            this.OrganisationId = -1;

          if (data.ProjectId != null) {
            this.assignedProjectId = data.ProjectId;
            $("#select_assigned_project_" + this.getId()).val(data.ProjectId);
            $("#select_assigned_project_" + this.getId()).trigger('change');
          }
          else
            this.assignedProjectId = -1;

          if (data.SiteShiftId != null) {
            this.$refs.shiftSelectorRef.selectShift(data.SiteShiftId);
            this.shiftId = data.SiteShiftId;
            //$("#select_assigned_shift_" + this.getId()).val(data.SiteShiftId);
            //$("#select_assigned_shift_" + this.getId()).trigger('change');
          }
          else
            this.shiftId = -1;


          if (data.Date != null) {
            $("#txt_date_assign_" + this.getId()).val(data.Date);
            this.selecteddate = data.Date;
          }
          else
            this.selecteddate = "";

          if (data.EndDate != null) {
            $("#txt_enddate_assign_" + this.getId()).val(data.EndDate);
          }
          $("#txt_time_" + this.getId()).val('');
          $("#txt_endtime_" + this.getId()).val('');
          if (data.StartTime != null) {
            $("#txt_time_" + this.getId()).val(data.StartTime);
          }
          if (data.EndTime != null) {
            $("#txt_endtime_" + this.getId()).val(data.EndTime);
          }


          if (data.TeamId != null) {
            this.selectedTeam = data.TeamId;
            this.$refs.teamSelectorRef.selectTeam(data.TeamId);
          }
          else {
            if (this.$refs.teamSelectorRef)
              this.$refs.teamSelectorRef.selectTeam("");
          }
        }
      },
      //onChangeShift() {
      //  this.shiftId = $("#select_assigned_shift_" + this.getId()).val();
      //},
      onChangeShift(id) {
        this.shiftId = id;
        //this.$forceUpdate();
      },
      onChangeOrganisation(thisContext) {

        thisContext.OrganisationId = $("#select_assigned_Organisation_" + thisContext.getId()).val();
        thisContext.loadMembers();
        //this.$forceUpdate();
      },
      async getUserOrganisations(user) {
        try {
          var thisContext = this;
          this.userOrganisations = [];
          this.$http.get('/api/Organizations/v1/User/GetUserOrganisations?user=' + user).then(async response => {
            thisContext.userOrganisations = response.data;

            if (thisContext.userOrganisations !== null && thisContext.userOrganisations.length > 0) {
              thisContext.userOrganisations = thisContext.userOrganisations.sort(function (a, b) {
                var x = a.Organization.toLowerCase();
                var y = b.Organization.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            $('#' + 'select_assigned_Organisation_' + this.getId()).select2();
          }).then((async response => {
            if (thisContext.userOrganisations !== null && thisContext.userOrganisations.length == 1) {
              var userCust = thisContext.userOrganisations[0];
              $("#select_assigned_Organisation_" + thisContext.getId()).val(userCust.Organisationid);
              $("#select_assigned_Organisation_" + thisContext.getId()).trigger('change');
            }
          }
          ));
        } catch (err) {
          //alert('some error:' + err)
        }
      },
      onChangeTeam(teamid) {
        this.selectedTeam = teamid;
        //this.$forceUpdate();
      },
      getId() {
        return this._uid;
      },
      /**
       * https://stackoverflow.com/questions/2909033/using-javascript-to-print-images
     * Prints an image by temporarily opening a popup
     * @param {string} src - image source to load
     * @returns {void}
     */
      printImage(src) {
        var procedureName = this.procedure.ProcedureName;
        if (procedureName == null || procedureName == "" || typeof (procedureName) == "undefined")
          procedureName = this.$t('scan_this_qrcode_title');
        var description = this.$t('scan_this_qrcode_description');
        var win = window.open('about:blank', "_new");
        win.document.open();
        //'   <body onload="window.print()" onafterprint="window.close()">',
        win.document.write([
          '<html>',
          '   <head>',
          '   <link href="/assets/css/all.css" rel="stylesheet" type="text/css">',
          '   </head>',
          '   <body>',
          '   <div class="container-fluid" style="max-width:270px">',
          '   <div class="row col-12">',
          '   <div class="card">',
          '       <h1 contenteditable="true" class="pt-3 pb-3 mb-0 text-center">' + procedureName + '</h1><div style="background-color:white;padding:0px;padding-top:0px;text-align:center"><img width="190" height="190" src="' + this.qrsource + '"/></div>',
          '       <div class="card-body" contenteditable="true">Scan the code, login and update your task!</div>',
          '   </div>',
          '   </div>',
          '   </div>',
          '   </body>',
          '</html>'
        ].join(''));
        win.document.close();
      },
      async loadMembers() {
        var thisContext = this;
        try {
          var url = "";
          if (this.OrganisationId != null && this.OrganisationId != -1) {
            url = '/api/Organization/GetOrganisationUsers?id=' + this.OrganisationId;
            this.users = [];
            this.$http.get(url).then(response => {

              if (response.data !== null && response.data.length > 0) {
                response.data = response.data.sort(function (a, b) {
                  var x = a.Name.toLowerCase();
                  var y = b.Name.toLowerCase();
                  return x < y ? -1 : x > y ? 1 : 0;
                });
              }


              Vue.set(this, "users", response.data)
              this.$forceUpdate();
              $("#select_assigned_user_" + this.getId()).select2({
                language: {
                  noResults: function () {
                    //thisContext.showAddUser = true;
                    //thisContext.newUserName = $("#select_assigned_user_" + thisContext.getId()).data("select2").dropdown.$search.val();
                    //newUserName
                    //return $("<a href='javascript:" + thisContext.test() + "'>Add</a>");
                    var obj = $("<a href='#'>" + thisContext.$t("add") + "</a>");
                    obj.on("click", function () {
                      thisContext.addUserByName($("#select_assigned_user_" + thisContext.getId()).data("select2").dropdown.$search.val())
                    });
                    return obj;
                  }
                }
              });

              var thisContext = this;
              setTimeout(function () {
                var sel = $("#select_assigned_user_" + thisContext.getId());
                sel.val(thisContext.assignedUser + "");
                $("#select_assigned_user_" + thisContext.getId()).trigger('change');
              }, 100)


            });
          }
          else {
            var thisContext = this;
            url = '/api/Users/v1';
            this.users = [];
            this.$http.get(url).then(async response => {
              var users = [];
              for (var i = 0; i < response.data.length; i++) {
                users.push({ User: response.data[i].UserName, Name: response.data[i].Name })
              }

              if (users !== null && users.length > 0) {
                users = users.sort(function (a, b) {
                  var x = a.Name.toLowerCase();
                  var y = b.Name.toLowerCase();
                  return x < y ? -1 : x > y ? 1 : 0;
                });
              }

              Vue.set(this, "users", users)
              this.$forceUpdate();
              $("#select_assigned_user_" + this.getId()).select2({
                language: {
                  noResults: function () {
                    //thisContext.showAddUser = true;
                    //thisContext.newUserName = $("#select_assigned_user_" + thisContext.getId()).data("select2").dropdown.$search.val();
                    //return "";
                    var obj = $("<a href='#'>" + thisContext.$t("add") + "</a>");
                    obj.on("click", function () {
                      thisContext.addUserByName($("#select_assigned_user_" + thisContext.getId()).data("select2").dropdown.$search.val())
                    });
                    return obj;
                  }
                }
              });

              var thisContext = this;
              setTimeout(function () {
                var sel = $("#select_assigned_user_" + thisContext.getId());
                sel.val(thisContext.assignedUser + "");
                $("#select_assigned_user_" + thisContext.getId()).trigger('change');
              }, 100)

            });
          }

        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      addUserByName(username) {
        this.newUserName = username;
        this.doAddUser(username, username);
      },
      async loadTeams(selected) {
        try {
          this.teams = [];
          this.$http.get('/api/Teams/v1?').then(response => {

            this.teams = response.data;


          })
        } catch (err) {
          alert('some error:' + err)
        }
      },
      loadShifts() {
        try {
          var url = '/api/Admin/v1/SiteShifts';
          this.$http.get(url).then(async response => {
            this.shifts = response.data;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      loadProjects() {
        try {
          var url = '/api/Projects/v1';
          this.$http.get(url).then(async response => {
            this.projects = response.data;

            if (this.projects !== null && this.projects.length > 0) {
              this.projects = this.projects.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      loadLocations() {
        try {

          var thisContext = this;

          var url = '/api/Procedures/v1/GetSiteLocations?includeSubLocations=true';
          this.$http.get(url).then(async response => {
            var locs = response.data;
            if (locs !== null && locs.length > 0) {
              locs = locs.sort(function (a, b) {
                var x = a.LocationName.toLowerCase();
                var y = b.LocationName.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            thisContext.locations = [];
            if (locs !== null && locs.length > 0) {
              locs.forEach(loc => {
                if (loc.ParentId === null) {
                  thisContext.locations.push(loc);
                  var childLocs = locs.filter(n => n.ParentId == loc.LocationId);
                  childLocs.forEach(subloc => {
                    subloc.LocationName = loc.LocationName + ' > ' + subloc.LocationName;
                    thisContext.locations.push(subloc);
                  });
                }
              });
            }

            $("#select_location_" + this.getId()).select2();

            //alert("thisContext.selectedLocation:" + thisContext.selectedLocation);

            if (thisContext.selectedLocation != "" && thisContext.selectedLocation != null) {
              setTimeout(function () {
                var sel = $("#select_location_" + thisContext.getId());

                sel.val(thisContext.selectedLocation + "");
                $("#select_location_" + thisContext.getId()).trigger('change');
              }, 100)
            }

          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      changeLocation(thisContext) {
        thisContext.selectedLocation = $("#select_location_" + thisContext.getId()).val();
        if (thisContext.selectedLocation === "") {
          thisContext.selectedLocation = null;
        }
      },
      changeProject() {
        this.assignedProjectId = $("#select_assigned_project_" + this.getId()).val();
      },
      open() {

        this.$refs.thisModal.open();
        this.initInitial();
        vm.$root.$emit('nux', this.$t('nux_procedure_assign'));

      },
      async doSave() {
        var proc = this.procedure;


        this.isStartTimeValid = true;
        this.isEndTimeValid = true;
        var starttime = $("#txt_time_" + this.getId()).val();
        var time = new RegExp('^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$');
        if (starttime != "") {
          if (time.test(starttime) === false) {
            this.isStartTimeValid = false;
            alert("Start time is not valid.");
          }
        }
        var endtime = $("#txt_endtime_" + this.getId()).val();
        if (endtime != "") {
          if (time.test(endtime) === false) {
            this.isEndTimeValid = false;
            alert("End time is not valid.");
          }
        }

        if (!this.isEndTimeValid || !this.isStartTimeValid) {
          return false;
        }


        if (this.assignedProjectId !== null && this.assignedProjectId < 0) {
          this.assignedProjectId = null;
        }
        if (this.shiftId !== null && this.shiftId < 0) {
          this.shiftId = null;
        }
        if (this.procedureScheduleId === '') {
          this.procedureScheduleId = null;
        }
        var request = {
          //procedurescheduleId:
          procedureId: proc.ProcedureId,
          name: proc.ProcedureName,
          description: "",
          istask: true,
          locationId: this.selectedLocation,
          teamId: this.selectedTeam,
          date: $("#txt_date_assign_" + this.getId()).val(),//proc.Datescheduled,
          enddate: $("#txt_enddate_assign_" + this.getId()).val(),
          starttime: $("#txt_time_" + this.getId()).val(),
          endtime: $("#txt_endtime_" + this.getId()).val(),
          userName: this.assignedUser,
          projectId: this.assignedProjectId,
          OrganisationId: this.OrganisationId,
          shiftId: this.shiftId,
          procedureScheduleId: this.procedureScheduleId,
        };
        ///api/Procedure/ScheduleProcedure
        try {
          var response = this.$http.post(
            '/api/Procedures/v1/ScheduleProcedure',
            request
          ).then(async response => {
            //alert('doSearch7')
            vm.$root.$emit('doSearch');
            vm.$root.$emit('procedure_editor_can_close');
            this.$refs.thisModal.close();
          });
        } catch (err) {
          alert(err);
        }

      },
      copyAssignUrl() {
        var thisContex = this;
        try {
          var tmpProcedureid = "";

          if (this.procedure != null && this.procedure.ProcedureId != 0)
            tmpProcedureid = this.procedure.ProcedureId;
          else
            tmpProcedureid = this.procedureId;

          if (this.selectedTeam == null || this.selectedTeam == 'null') {
            this.selectedTeam = '';
          }
          if (this.selectedLocation == null || this.selectedLocation == 'null') {
            this.selectedLocation = '';
          }

          var url = '/api/Procedures/v1/GetLinkCode?procedureId=' + tmpProcedureid + '&locationId=' + this.selectedLocation + '&teamId=' + this.selectedTeam + '&projectId=' + this.assignedProjectId + '&organisationId=' + this.OrganisationId + '&shiftId=' + this.shiftId + '&username=' + this.assignedUser
            + '&procedureScheduleId=' + this.procedureScheduleId + '&authType=' + this.selectedAuth;
          this.$http.get(url).then(async response => {

            this.copyUrl = response.data.Url;

            try {
              let result = await thisContex.copy(response.data.Url);
              thisContex.confirmCopy = true;
            }
            catch (e) {
              console.error(e);
              this.copyError = true;
            }
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      getQRCodeUrl() {
        try {
          var url = this.getUrl('GetQRCodeUrl');
          this.$http.get(url).then(response => {
            this.qrcodeurl = response.data.Url;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },

      sendEmailForUrl() {
        try {
          if (ValidateEmail(this.sendORSms) === false && isNaN(this.sendORSms)) {
            this.msgSmsOrEmail = this.$t('enter_email_or_sms');
            return false;
          }
          var url = this.getUrl('SendEmailShareProcSch') + '&emailorsms=' + this.sendORSms;
          this.$http.get(url).then(response => {
            //this.qrcodeurl = response.data.Url;
            if (response.data.Error != null && response.data.Error != "") {
              this.msgSmsOrEmail = response.data.Error;
            }
            else
              this.msgSmsOrEmail = this.$t('email_or_sms_sent');
            this.sendORSms = '';
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      getUrl(methodname) {
        var tmpProcedureid = "";

        if (this.procedure != null && this.procedure.ProcedureId != 0)
          tmpProcedureid = this.procedure.ProcedureId;
        else
          tmpProcedureid = this.procedureId;
        var url = '/api/Procedures/v1/' + methodname + '?procedureId=' + tmpProcedureid + '&locationId=' + this.locationId + '&teamId=' + this.teamId + '&projectId=' + this.projectId + '&organisationId=' + this.organisationId + '&shiftId=' + this.shiftId + '&username=' + this.assignedUser
          + '&procedureScheduleId=' + this.procedureScheduleId + '&authType=' + this.selectedAuth;
        return url;
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      initInitial() {

        if (this.isLoaded == true)
          return;

        this.isLoaded = true;

        var thisContext = this;
        this.thisProcedure = this.$store.state.procedure;
        this.getUserOrganisations(this.user);
        this.init();

        $('.select-search').select2();

        $("#select_assigned_user_" + this.getId()).on('select2:select', function (e) {

          if (this.value == "new") {
            thisContext.showAddUser = true;
            thisContext.assignedUser = "";
          }
          else {
            thisContext.assignedUser = this.value;
            thisContext.showAddUser = false;
          }

        });

        $("#select_assigned_Organisation_" + this.getId()).on('select2:select', function (e) {
          if (this.value == "new") {
            thisContext.showAddOrganisation = true;
            thisContext.selectedOrganisation = "";
          }
          else {
            thisContext.onChangeOrganisation(thisContext);
          }
        });

        $("#select_location_" + this.getId()).on('select2:select', function (e) {

          if (this.value == "new") {
            thisContext.showAddLocation = true;
            thisContext.selectedLocation = "";
          }
          else {
            thisContext.changeLocation(thisContext);
          }
        });

        $("#select_assigned_project_" + this.getId()).on('select2:select', this.changeProject);

        //$("#select_assigned_Organisation_" + this.getId()).on('select2:select', this.onChangeOrganisation);


        //$("#select_assigned_shift_" + this.getId()).change(this.onChangeShift);
        var datepickerObj = $('.calendarassignment').daterangepicker({
          autoUpdateInput: false,
          singleDatePicker: true,
          showDropdowns: true,
          minYear: 1901,
          maxYear: parseInt(moment().format('YYYY'), 10),
          drops: 'down',
          opens: 'center',
          locale: {
            format: 'YYYY-MM-DD',
            cancelLabel: 'Clear'
          },
        }, function (start, end) {

          // Do something
          //$(this).val(start.format('YYYY-MM-DD'));

        });

        $('.calendarassignment').keyup(function (e) {
          if (e.keyCode == 8 || e.keyCode == 46) {
            $(this).val('');
          }
        })

        $('.calendarassignment').on('apply.daterangepicker', function (ev, picker) {
          $(this).val(picker.startDate.format('YYYY-MM-DD'))
        });

        $('.calendarassignment').on('cancel.daterangepicker', function (ev, picker) {
          $(this).val('');
        });

      },
      init() {


        this.loadProjects();
        this.loadLocations();
        this.loadShifts();
        this.loadTeams();
        this.title = this.$t('assign_to');

        this.$forceUpdate();
      }
    },
    computed: {
      qrsource: {
        get: function () {
          var tmpProcedureid = "";
          if (this.procedure != null && this.procedure.ProcedureId != 0)
            tmpProcedureid = this.procedure.ProcedureId;
          else
            tmpProcedureid = this.procedureId;
          if (this.teamId == undefined)
            this.teamId = '';
          if (this.locationId == undefined)
            this.locationId = '';
          if (this.projectId == undefined)
            this.projectId = '';
          if (this.organisationId == undefined)
            this.organisationId = '';
          if (this.procedureScheduleId == undefined)
            this.procedureScheduleId = '';
          return apiUrl + '/api/Procedures/v1/GetQRCode?procedureId=' + tmpProcedureid + '&locationId=' + this.locationId + '&teamId=' + this.teamId + '&projectId=' + this.projectId + '&organisationId=' + this.organisationId + '&shiftId=' + this.shiftId + '&username=' + this.assignedUser + '&procedureScheduleId=' + this.procedureScheduleId + '&authType=' + this.selectedAuth + '&siteid=' + this.siteid;
        },
      },
      linkSrc: {
        get: function () {
          var tmpProcedureid = "";
          if (this.procedure != null && this.procedure.ProcedureId != 0)
            tmpProcedureid = this.procedure.ProcedureId;
          else
            tmpProcedureid = this.procedureId;
          if (this.teamId == undefined)
            this.teamId = '';
          if (this.locationId == undefined)
            this.locationId = '';
          if (this.projectId == undefined)
            this.projectId = '';
          if (this.organisationId == undefined)
            this.organisationId = '';
          if (this.procedureScheduleId == undefined)
            this.procedureScheduleId = '';
          return apiUrl + '/api/Procedures/v1/GetQRCode?procedureId=' + tmpProcedureid + '&locationId=' + this.locationId + '&teamId=' + this.teamId + '&projectId=' + this.projectId + '&organisationId=' + this.organisationId + '&shiftId=' + this.shiftId + '&username=' + this.assignedUser + '&procedureScheduleId=' + this.procedureScheduleId + '&authType=' + this.selectedAuth + '&siteid=' + this.siteid;
        },
      },

    },
    watch: {
      user: function (newVal, oldVal) {
        if (newVal !== "") {
          this.getUserOrganisations(newVal);
        }
      },
      sharingOption: function (newVal, oldVal) {
        if (newVal == true)
          this.title = this.$t('share');
        else
          this.title = this.$t('assign_to');
      }
    },
    mounted() {
      if (!$('#shareEmailSmsForm').valid())
        return false;
      var buttonId = '#copyButton_' + this.getId();
      var thisContext = this;
      $(buttonId).on("click", function () {
        thisContext.copyAssignUrl();
      });

      this.loadMembers();

    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>
<style scoped>
  .option_child_loc {
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-assign.vue